class CheckboxGroupState extends WidgetState {
    constructor() {
        super()
    }

    setCheckboxState(identifier, checkboxState) {
        this.childrenStates[identifier] = checkboxState;
    }

    getCheckboxState(identifier) {
        return this.childrenStates[identifier];
    }

    /**
     * check if two instances of widgetState are equal
     * @param otherWidgetState
     */
    equals(otherWidgetState) {
        if(this.enabled != null && otherWidgetState.enabled != null) {
            if(this.enabled != otherWidgetState.enabled) return false;
        }

        for(var checkboxIdentifier in otherWidgetState.checkboxStates) {
            var thisCheckBoxState = this.getChildState(checkboxIdentifier);
            var otherCheckBoxState = otherWidgetState.getChildState(checkboxIdentifier);

            if(!thisCheckBoxState.equals(otherCheckBoxState)) return false;
        }

        if(!this.equalChildren(otherWidgetState)) {
            return false;
        }

        return true;
    }

    /**
     * Create a copy of this state
     */
    getCopy() {
        var result = new CheckboxGroupState();

        result.enabled = this.enabled;
        result.copyChildrenStates(this);

        return result;
    }
}

